import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TextArea from "antd/es/input/TextArea";
import { Button, Modal, Form, Radio } from "antd";
import {
  vehicleAddCommentsApiUrl,
  vehicleTestListUrl,
} from "components/Common/endpoints";
import { getApis, postApis } from "components/Common/apis";
import {
  setHBHistoryData,
  setDynoHistoryData,
  setSelectedHBTestId,
} from "reducers/eolTestsSlice";

const Comment = ({ isModalOpen, handleCloseModal, testId, formName }) => {
  const eol = useSelector((state) => state.eolTests);
  const vehicle = useSelector((state) => state.eol);
  const vehicleDetails = vehicle?.vehicleDetails;
  const selectedTab = eol?.selectedTab;
  const authToken = localStorage.getItem("authToken");
  const dispatch = useDispatch();

  const getConHistoryData = async () => {
    await getApis(
      vehicleTestListUrl,
      {
        vIdVal: vehicleDetails?.vehId,
        type: "CONNECTIVITY",
      },
      authToken
    )
      .then((res) => {
        dispatch(
          setHBHistoryData({
            list: res?.data?.content,
            total: res?.data?.totalElements,
          })
        );
        dispatch(setSelectedHBTestId(testId));
      })
      .catch((e) => console.log(e));
  };

  const getDynoHistoryData = async () => {
    await getApis(
      vehicleTestListUrl,
      {
        vIdVal: vehicleDetails?.vehId,
        type: "DYNO",
      },
      authToken
    )
      .then((res) =>
        dispatch(
          setDynoHistoryData({
            list: res?.data?.content,
            total: res?.data?.totalElements,
          })
        )
      )
      .catch((e) => console.log(e));
  };

  let initialValues = {
    key: "Is the vehicle in good condition without any issues so far?",
    testId: testId,
    commentType: "TEXT",
    value: "yes",
    comment: "",
  };

  const addComment = async (values) => {
    const body = {
      ...initialValues,
      value: values?.value || "yes",
      comment: values?.comment,
    };

    await postApis(vehicleAddCommentsApiUrl, body, authToken)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Commented successfully!");
          handleCloseModal();
          if (selectedTab === "heartBeat") {
            getConHistoryData();
          } else if (selectedTab === "dyno") {
            getDynoHistoryData();
          }
        }
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      });
  };

  const onFinish = async (values) => {
    addComment(values);
  };

  const options = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  return (
    <Modal
      title="Vehicle Status"
      open={isModalOpen}
      closable={false}
      footer={[]}
    >
      <Form
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
        name={formName}
      >
        Is the vehicle in good condition without any issues so far?
        <Form.Item key="radio" name="value">
          <Radio.Group name="value" className="mtb1">
            {options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          key="comment"
          name="comment"
          rules={[
            {
              required: true,
              message: "Can't be blank",
            },
          ]}
        >
          <TextArea
            placeholder="Comments"
            rows="3"
            data-testid="comment-input"
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="comment-btn right"
          >
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Comment;
